import { notification, message } from 'antd';
import dayjs from 'dayjs';
import { ResponseStatus, TermDTO, TermRequestDTO, Unit, ExtendedReservationDTO } from 'types';
import { formatNumber, removeMilisDouble } from './uiUtils';

const unitMapping: Record<Unit, Unit[]> = {
    ks: ['ks'],
    kg: ['kg', 'g'],
    g: ['kg', 'g'],
    l: ['l', 'ml'],
    ml: ['l', 'ml'],
};

export const isTodayInRange = (valid_from: string, valid_to: string) => {
    const today = dayjs();
    const from = dayjs(valid_from);
    const to = dayjs(valid_to);

    return (today.isAfter(from, 'day') || today.isSame(from, 'day')) && (today.isBefore(to, 'day') || today.isSame(to, 'day'));
};

export const isDateToday = (date?: string) => {
    if (isUndefined(date)) return false;

    return dayjs(date).isSame(dayjs(), 'day');
};

export const isDateInFuture = (date?: string) => {
    if (isUndefined(date)) return false;

    return dayjs(date) > dayjs();
};

export const isDateTodayOrInPast = (date?: string) => {
    if (isUndefined(date)) return false;

    return dayjs(date) <= dayjs();
};

export const isUndefined = (sth: any) => {
    return sth === undefined || sth === null || sth === '';
};

export const isEmpty = (sth: any[]) => {
    return sth === undefined || sth === null || sth.length === 0;
};

export const isEmptyObject = (sth: any) => {
    return sth === undefined || sth === null || Object.keys(sth).length === 0;
};

export const createNotification = (type: ResponseStatus, description: string, header: string, duration?: number) => {
    notification[type]({
        duration: duration || 6,
        placement: 'topRight',
        message: header,
        description: description,
        showProgress: true,
        pauseOnHover: true,
    });
};

export const createMessage = (type: ResponseStatus, text: string) => {
    message[type]({
        key: text,
        duration: 6,
        content: text,
        onClick: () => message.destroy(text),
    });
};

export const convertReservationsIntoEvents = (data: ExtendedReservationDTO[]) => {
    return data.map((reservation) => ({
        id: reservation.id.toString(),
        start: reservation.work_date + 'T' + reservation.time_from,
        end: reservation.work_date + 'T' + reservation.time_to,
        title: reservation.customer.name + ' ' + reservation.customer.surname,
        groupId: formatNumber(reservation.price),
        backgroundColor: reservation.status === 'A' ? 'green' : reservation.status === 'N' ? 'yellow' : 'red',
        borderColor: reservation.status === 'A' ? 'green' : reservation.status === 'N' ? 'yellow' : 'red',
        extendedProps: reservation,
    }));
};

/* FOR TERM PAGE */
export const convertTerms = (data: TermDTO[], selectedTerms: number[]) => {
    return data.map((term: TermDTO) => ({
        id: term.id.toString(),
        start: term.work_date + 'T' + term.time_from,
        end: term.work_date + 'T' + term.time_to,
        title: removeMilisDouble(term.time_from, term.time_to),
        extendedProps: { ...term, selected: selectedTerms.includes(term.id) },
    }));
};

export const isTermInConflict = (terms: TermRequestDTO[], _term: TermRequestDTO) => {
    const list = terms.filter((term) => _term.work_date === term.work_date && term.time_from < _term.time_to && _term.time_from < term.time_to);
    return list.length > 0;
};

export const isValidUnit = (baseUnit: Unit, chosenUnit: Unit) => {
    return unitMapping[baseUnit].includes(chosenUnit);
};

export const getValidUnits = (baseUnit: Unit) => {
    return unitMapping[baseUnit];
};

export const convertToUnit = (quantity: number, unitFrom: Unit, unitTo: Unit) => {
    if (unitFrom === unitTo) return quantity;

    if (unitFrom in ['kg', 'l']) return quantity * 1000;
    else return quantity / 1000;
};
